var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.667 10 10 11.667 8.333 10 10 8.333 11.667 10zM10 5l1.767 1.767 2.083-2.084L10 .833l-3.85 3.85 2.083 2.084L10 5zm-5 5 1.767-1.767L4.683 6.15.833 10l3.85 3.85 2.084-2.083L5 10zm10 0-1.767 1.767 2.084 2.083 3.85-3.85-3.85-3.85-2.084 2.083L15 10zm-5 5-1.767-1.767-2.083 2.084 3.85 3.85 3.85-3.85-2.083-2.084L10 15z"
})));
export default SvgApi;